import axios from 'axios';
import { getBearerGrantTypeAuthHeaders } from '../helpers/auth_helpers';

export const getFSCDisclaimer = async (options) => {
  const requestOptions = {
    method: 'get',
    url: `${API_HOST}/api/configs/fsc-disclaimer`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: getBearerGrantTypeAuthHeaders(),
    },
  };
  if (options?.cancelToken) {
    requestOptions.cancelToken = options?.cancelToken;
  }

  return axios(requestOptions);
};
